var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSocialTelegram = function SvgIconSocialTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M17.258 3.045s1.62-.631 1.484.901c-.045.632-.45 2.841-.765 5.23l-1.079 7.08s-.09 1.037-.9 1.218c-.808.18-2.022-.632-2.247-.812-.18-.136-3.373-2.165-4.497-3.156-.315-.271-.675-.812.045-1.443l4.721-4.51c.54-.54 1.08-1.803-1.17-.27l-6.295 4.283s-.72.452-2.068.046l-2.924-.902s-1.079-.677.765-1.353c4.497-2.119 10.028-4.283 14.93-6.312Z"
  })));
};
export default SvgIconSocialTelegram;